import React from 'react'
import * as _ from 'lodash'
import { QuestionTypeLabels, isTextBlockQuestionType } from '../types'
import { createMarkup } from '../../core/utils/helpers'

export const QuestionDetails = props => {
  const { question, index, questionByQuestionId } = props
  const {
    questionId,
    question: label,
    questionType,
    options,
    conditionedOnQuestionId,
    conditionedOnAnswer,
    isRequired,
  } = question
  const hasIndex = !_.isNil(index)
  const isTextBlock = isTextBlockQuestionType(questionType)
  return (
    <div key={questionId}>
      {isTextBlock ? (
        <>
          {hasIndex && (
            <p>
              <b>{`${index + 1}. `}</b>
            </p>
          )}
          <div className="scheduler-global-fix" dangerouslySetInnerHTML={createMarkup(label)} />
        </>
      ) : (
        <p>
          <b>
            {hasIndex ? `${index + 1}. ` : ''}
            {label}
            {isRequired ? '*' : ''}
          </b>
        </p>
      )}
      <p>
        <i>{QuestionTypeLabels[questionType] || questionType}</i>
      </p>
      {!isTextBlockQuestionType(questionType) && !!_.get(options, 'length') && (
        <ul>
          {_.map(options, (option, index) => (
            <li key={index}>{option}</li>
          ))}
        </ul>
      )}
      {conditionedOnQuestionId && questionByQuestionId && (
        <>
          <p>Conditioned on question: '{questionByQuestionId[conditionedOnQuestionId].question}'</p>
          <p>Conditioned on answer: '{conditionedOnAnswer}'</p>
        </>
      )}
    </div>
  )
}
